import React, { useEffect, Component } from 'react';
import { Logo } from '../components/Logo';
import { ArrowLeft, Check, Copy } from 'lucide-react';
export function BrandBook() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    // Simple visual feedback could be added here
  };
  const ColorSwatch = ({
    name,
    hex,
    className
  }: {
    name: string;
    hex: string;
    className: string;
  }) => <div className="flex flex-col" data-id="element-534">
      <div className={`h-24 w-full rounded-lg shadow-sm mb-2 border border-gray-100 ${className}`} data-id="element-535"></div>
      <div className="flex justify-between items-center" data-id="element-536">
        <span className="font-medium text-sm text-gray-900" data-id="element-537">{name}</span>
        <button onClick={() => copyToClipboard(hex)} className="text-xs text-gray-500 hover:text-gray-900 flex items-center gap-1 transition-colors" title="Copiar HEX" data-id="element-538">
          {hex} <Copy className="w-3 h-3" data-id="element-539" />
        </button>
      </div>
    </div>;
  return <div className="min-h-screen bg-gray-50 pb-24" data-id="element-540">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50" data-id="element-541">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-542">
          <a href="#" className="flex items-center text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-543">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-544" />
            Volver a la web
          </a>
          <div className="text-sm font-bold text-gray-900" data-id="element-545">Brand Book</div>
        </div>
      </nav>

      {/* Hero - Huge Logo */}
      <section className="bg-white py-24 sm:py-32 border-b border-gray-200 overflow-hidden" data-id="element-546">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center justify-center text-center" data-id="element-547">
          <div className="mb-8" data-id="element-548">
            <span className="text-sm font-bold tracking-widest text-blue-600 uppercase bg-blue-50 px-3 py-1 rounded-full" data-id="element-549">
              Identidad Visual
            </span>
          </div>

          {/* Huge Custom Logo */}
          <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10 transform scale-100 md:scale-125 lg:scale-150 my-12" data-id="element-550">
            <svg width="120" height="120" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="drop-shadow-xl" data-id="element-551">
              <rect x="8" y="6" width="24" height="28" rx="4" fill="#BFDBFE" opacity="0.5" data-id="element-552" />
              <rect x="12" y="10" width="20" height="24" rx="3" fill="#2563EB" data-id="element-553" />
              <path d="M17 22L20 25L27 16" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-554" />
              <line x1="16" y1="16" x2="20" y2="16" stroke="white" strokeWidth="2" strokeLinecap="round" data-id="element-555" />
            </svg>
            <h1 className="text-7xl md:text-8xl tracking-tight leading-none" data-id="element-556">
              <span className="font-semibold text-gray-900" data-id="element-557">Inspect</span>
              <span className="font-bold text-blue-600" data-id="element-558">IA</span>
            </h1>
          </div>

          <p className="mt-16 text-xl text-gray-500 max-w-2xl" data-id="element-559">
            Guía de estilos y componentes para mantener la consistencia visual
            en todos los puntos de contacto de InspectIA.
          </p>
        </div>
      </section>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-24" data-id="element-560">
        {/* Colors */}
        <section data-id="element-561">
          <div className="mb-8 border-b border-gray-200 pb-4" data-id="element-562">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-563">Colores</h2>
            <p className="text-gray-500 mt-2" data-id="element-564">
              Paleta de colores principal y secundaria.
            </p>
          </div>

          <div className="space-y-12" data-id="element-565">
            <div data-id="element-566">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-567">
                Marca (Primary Blue)
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4" data-id="element-568">
                <ColorSwatch name="Blue 50" hex="#eff6ff" className="bg-blue-50" data-id="element-569" />
                <ColorSwatch name="Blue 100" hex="#dbeafe" className="bg-blue-100" data-id="element-570" />
                <ColorSwatch name="Blue 500" hex="#3b82f6" className="bg-blue-500" data-id="element-571" />
                <ColorSwatch name="Blue 600 (Base)" hex="#2563eb" className="bg-blue-600 ring-2 ring-offset-2 ring-blue-600" data-id="element-572" />
                <ColorSwatch name="Blue 700" hex="#1d4ed8" className="bg-blue-700" data-id="element-573" />
              </div>
            </div>

            <div data-id="element-574">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-575">
                Neutrales (Grays)
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-6 gap-4" data-id="element-576">
                <ColorSwatch name="Gray 50" hex="#f9fafb" className="bg-gray-50" data-id="element-577" />
                <ColorSwatch name="Gray 100" hex="#f3f4f6" className="bg-gray-100" data-id="element-578" />
                <ColorSwatch name="Gray 200" hex="#e5e7eb" className="bg-gray-200" data-id="element-579" />
                <ColorSwatch name="Gray 500" hex="#6b7280" className="bg-gray-500" data-id="element-580" />
                <ColorSwatch name="Gray 700" hex="#374151" className="bg-gray-700" data-id="element-581" />
                <ColorSwatch name="Gray 900" hex="#111827" className="bg-gray-900" data-id="element-582" />
              </div>
            </div>

            <div data-id="element-583">
              <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-584">
                Semánticos (Estados)
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-585">
                <ColorSwatch name="Success (Green 500)" hex="#22c55e" className="bg-green-500" data-id="element-586" />
                <ColorSwatch name="Warning (Amber 500)" hex="#f59e0b" className="bg-amber-500" data-id="element-587" />
                <ColorSwatch name="Error (Red 500)" hex="#ef4444" className="bg-red-500" data-id="element-588" />
                <ColorSwatch name="WhatsApp (Brand)" hex="#25D366" className="bg-[#25D366]" data-id="element-589" />
              </div>
            </div>
          </div>
        </section>

        {/* Typography */}
        <section data-id="element-590">
          <div className="mb-8 border-b border-gray-200 pb-4" data-id="element-591">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-592">Tipografía</h2>
            <p className="text-gray-500 mt-2" data-id="element-593">
              Usamos Inter para toda la interfaz, priorizando la legibilidad.
            </p>
          </div>

          <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm" data-id="element-594">
            <div className="flex flex-col md:flex-row gap-12" data-id="element-595">
              <div className="flex-1 space-y-8" data-id="element-596">
                <div data-id="element-597">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-598">
                    Display (text-5xl / text-6xl, font-extrabold)
                  </div>
                  <div className="text-5xl font-extrabold text-gray-900 tracking-tight" data-id="element-599">
                    Visita la obra.
                  </div>
                </div>
                <div data-id="element-600">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-601">
                    Heading 2 (text-3xl / text-4xl, font-bold)
                  </div>
                  <div className="text-3xl font-bold text-gray-900" data-id="element-602">
                    Planes simples y transparentes
                  </div>
                </div>
                <div data-id="element-603">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-604">
                    Heading 3 (text-xl, font-bold)
                  </div>
                  <div className="text-xl font-bold text-gray-900" data-id="element-605">
                    Generación automática
                  </div>
                </div>
                <div data-id="element-606">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-607">
                    Subtitle / Lead (text-lg, text-gray-600)
                  </div>
                  <div className="text-lg text-gray-600" data-id="element-608">
                    InspectIA convierte tus fotos, audios y notas en un informe
                    técnico profesional.
                  </div>
                </div>
                <div data-id="element-609">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-610">
                    Body (text-base, text-gray-700)
                  </div>
                  <div className="text-base text-gray-700" data-id="element-611">
                    El problema principal es que los profesionales pierden horas
                    transcribiendo información después de visitar la obra.
                  </div>
                </div>
                <div data-id="element-612">
                  <div className="text-sm text-gray-500 mb-1" data-id="element-613">
                    Small / Overline (text-sm, font-semibold, uppercase)
                  </div>
                  <div className="text-sm font-semibold text-blue-600 tracking-wide uppercase" data-id="element-614">
                    La solución
                  </div>
                </div>
              </div>

              <div className="w-full md:w-64 bg-gray-50 rounded-xl p-6 border border-gray-100 h-fit" data-id="element-615">
                <div className="text-6xl font-bold text-gray-900 mb-4" data-id="element-616">Aa</div>
                <div className="text-xl font-semibold text-gray-900 mb-2" data-id="element-617">
                  Inter
                </div>
                <p className="text-sm text-gray-500 mb-4" data-id="element-618">Sans-serif</p>
                <div className="space-y-2 text-sm" data-id="element-619">
                  <div className="font-normal" data-id="element-620">Regular (400)</div>
                  <div className="font-medium" data-id="element-621">Medium (500)</div>
                  <div className="font-semibold" data-id="element-622">SemiBold (600)</div>
                  <div className="font-bold" data-id="element-623">Bold (700)</div>
                  <div className="font-extrabold" data-id="element-624">ExtraBold (800)</div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* UI Elements */}
        <section data-id="element-625">
          <div className="mb-8 border-b border-gray-200 pb-4" data-id="element-626">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-627">Componentes UI</h2>
            <p className="text-gray-500 mt-2" data-id="element-628">
              Elementos interactivos y contenedores principales.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-629">
            {/* Buttons */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm" data-id="element-630">
              <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-631">
                Botones
              </h3>

              <div className="space-y-6" data-id="element-632">
                <div data-id="element-633">
                  <div className="text-sm text-gray-500 mb-3" data-id="element-634">
                    Primary (bg-blue-600)
                  </div>
                  <button className="inline-flex justify-center items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 shadow-sm transition-colors" data-id="element-635">
                    Probar InspectIA
                  </button>
                </div>

                <div data-id="element-636">
                  <div className="text-sm text-gray-500 mb-3" data-id="element-637">
                    Secondary (bg-white, border-gray-300)
                  </div>
                  <button className="inline-flex justify-center items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 shadow-sm transition-colors" data-id="element-638">
                    Ver cómo funciona
                  </button>
                </div>

                <div data-id="element-639">
                  <div className="text-sm text-gray-500 mb-3" data-id="element-640">
                    Ghost / Nav Link
                  </div>
                  <button className="text-sm font-medium text-gray-600 hover:text-blue-600 transition-colors" data-id="element-641">
                    Enlace de navegación
                  </button>
                </div>
              </div>
            </div>

            {/* Cards & Badges */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8 shadow-sm" data-id="element-642">
              <h3 className="text-lg font-semibold text-gray-900 mb-6" data-id="element-643">
                Tarjetas y Badges
              </h3>

              <div className="space-y-6" data-id="element-644">
                <div data-id="element-645">
                  <div className="text-sm text-gray-500 mb-3" data-id="element-646">
                    Card Standard (rounded-2xl, shadow-sm)
                  </div>
                  <div className="bg-white rounded-2xl border border-gray-200 p-6 shadow-sm" data-id="element-647">
                    <h4 className="font-bold text-gray-900 mb-2" data-id="element-648">
                      Contenedor Principal
                    </h4>
                    <p className="text-sm text-gray-600" data-id="element-649">
                      Usado para planes de precios, beneficios y formularios.
                    </p>
                  </div>
                </div>

                <div data-id="element-650">
                  <div className="text-sm text-gray-500 mb-3" data-id="element-651">Badges</div>
                  <div className="flex flex-wrap gap-3" data-id="element-652">
                    <span className="bg-blue-50 text-blue-600 text-xs font-bold px-3 py-1 rounded-full border border-blue-100" data-id="element-653">
                      Informativo
                    </span>
                    <span className="bg-red-50 text-red-600 text-xs font-bold px-3 py-1 rounded-full border border-red-100" data-id="element-654">
                      Alerta / Problema
                    </span>
                    <span className="bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-655">
                      Destacado
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Logo Variations */}
        <section data-id="element-656">
          <div className="mb-8 border-b border-gray-200 pb-4" data-id="element-657">
            <h2 className="text-3xl font-bold text-gray-900" data-id="element-658">Logotipo</h2>
            <p className="text-gray-500 mt-2" data-id="element-659">
              Variaciones permitidas del logo.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-660">
            <div className="bg-white rounded-2xl border border-gray-200 p-12 shadow-sm flex flex-col items-center justify-center" data-id="element-661">
              <div className="text-sm text-gray-500 mb-8 self-start" data-id="element-662">
                Versión Principal (Fondo Claro)
              </div>
              <Logo size="lg" variant="dark" data-id="element-663" />
            </div>

            <div className="bg-gray-900 rounded-2xl border border-gray-800 p-12 shadow-sm flex flex-col items-center justify-center" data-id="element-664">
              <div className="text-sm text-gray-400 mb-8 self-start" data-id="element-665">
                Versión Negativa (Fondo Oscuro)
              </div>
              <Logo size="lg" variant="light" data-id="element-666" />
            </div>
          </div>
        </section>
      </div>
    </div>;
}